module.exports = __webpack_public_path__ + "static/media/RoundedRect_Tertiary@2x.fd396d39.png";